import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { LoginComponent } from './login.component'
import { EmailLoginComponent } from './email-login.component'
import { SharedModule } from '../../shared/shared.module'
import { FunnelSharedModule } from '../shared/funnel-shared.module'
import { LoginRoutingModule } from './login-routing.module'
import { FormErrorsModule } from '../../shared/form-errors/form-errors.module'
import { GoogleAuthService } from '../../shared/services/google-auth.service'

@NgModule({
  imports: [CommonModule, SharedModule, FunnelSharedModule, ReactiveFormsModule, LoginRoutingModule, FormErrorsModule],
  exports: [EmailLoginComponent, LoginComponent],
  declarations: [EmailLoginComponent, LoginComponent],
  providers: [GoogleAuthService]
})
export class LoginModule {}
